module.exports = __webpack_public_path__ + "img/image3.4b8ad74d.png";